import React from "react";
import {RouteComponentProps} from "../../../routers/withRouterProps";
import Alert from "react-s-alert";
import {useMutation} from "react-query";
import {SftpConfigForm} from "./SftpConfigForm";
import {Spinner} from "../../../atoms/spinner";
import {HubAndSpokeService} from "../../../services/HubAndSpokeService";
import {withRouterProps} from "../../../routers/withRouterProps";

export const SftpConfigCreate = withRouterProps(
  ({history}: RouteComponentProps) => {
    const {mutate: createSftpConfig, isLoading} = useMutation(
      HubAndSpokeService.createSftpConfig,
      {
        onSuccess: () => {
          Alert.success("SFTP configuration was successfully created.");
          history.push("/admin/hub-and-spoke/sftp-configurations");
        },
        onError: async (error: any) => {
          Alert.error(error?.data?.detail);
        },
      },
    );
    return (
      <>
        {!isLoading ? (
          <SftpConfigForm onSubmit={createSftpConfig} />
        ) : (
          <Spinner />
        )}
      </>
    );
  },
);
